import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";
import { getStockByIdAndBranch } from "../../../../../Stock/StockAnalysis/Redux/api";

// get DeliveryNote
export const getDeliveryNote = createAsyncThunk("deliveryNote/getDeliveryNote", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getDeliveryNote({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all DeliveryNote
export const getAllDeliveryNote = createAsyncThunk(
  "deliveryNote/getAllDeliveryNote",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllDeliveryNote();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("deliveryNote/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("deliveryNote/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "deliveryNote/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageDeliveryNote({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get Delivery Note Additional Charge List
export const getDeliveryNoteAdditionalChargeList = createAsyncThunk(
  "deliveryNote/getDeliveryNoteAdditionalChargeList",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getDeliveryNoteAdditionalChargeList(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get item by id
export const getDeliveryNoteById = createAsyncThunk(
  "deliveryNote/getDeliveryNoteById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getDeliveryNoteById(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

export const getSaleOrderDetailsById = createAsyncThunk(
  "deliveryNote/getSaleOrderDetailsById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleOrderDetailsById(id);

      if (data?.data.saleOrderDetails?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data.data?.saleOrderDetails.map(async (detail) => {
          const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id); // getStockByIdAndBranch

          if (stockData.data?.length > 0) {
            return {
              ...detail,
              // availableStock stock from stockData
              availableStock: stockData.data[0]?.closingStock || "",
            };
          } else {
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return { ...data, data: { ...data.data, saleOrderDetails: updatedDetails } };
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create DeliveryNote
export const createDeliveryNote = createAsyncThunk(
  "deliveryNote/createDeliveryNote",
  async (data, { rejectWithValue }) => {
    const {
      deliveryNotesDetails,
      deliveryNoteMainAdditionalChargeCost,
      deliveryNumber,
      deliveryDocNo,
      destination,
      salesman,
      plSlipNumber,
      narration,
      branch,
      salesOrderMain,
      deliveryNotesMainPartyDetails,
      deliveryNotesMainVehicleDetail,
      partyAccount,
      discountAmount,
      grandTotal,
      vatAmount,
    } = data;

    try {
      const body = JSON.stringify({
        deliveryNotesDetails,
        deliveryNoteMainAdditionalChargeCost,
        deliveryNumber,
        deliveryDocNo,
        destination,
        salesman,
        plSlipNumber,
        narration,
        branch,
        salesOrderMain,
        deliveryNotesMainPartyDetails,
        deliveryNotesMainVehicleDetail,
        partyAccount,
        discountAmount,
        grandTotal,
        vatAmount,
      });
      const { data } = await API.createDeliveryNote(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updateDeliveryNote = createAsyncThunk(
  "deliveryNote/updateDeliveryNote",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const {
      deliveryNotesDetails,
      deliveryNoteMainAdditionalChargeCost,
      deliveryNumber,
      salesman,
      plSlipNumber,
      narration,
      branch,
      salesOrderMain,
      partyAccount,
      deliveryNotesMainPartyDetails,
      deliveryNotesMainVehicleDetail,
      discountAmount,
      grandTotal,
      vatAmount,
    } = values;
    try {
      const body = JSON.stringify({
        deliveryNotesDetails,
        deliveryNoteMainAdditionalChargeCost,
        deliveryNumber,
        salesman,
        plSlipNumber,
        narration,
        branch,
        salesOrderMain,
        partyAccount,
        deliveryNotesMainPartyDetails,
        deliveryNotesMainVehicleDetail,
        discountAmount,
        grandTotal,
        vatAmount,
      });
      const { data } = await API.updateDeliveryNote(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk("deliveryNote/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
